import { render, staticRenderFns } from "./ProprietaryChineseMedicine.vue?vue&type=template&id=cf01b40c&scoped=true&"
import script from "./ProprietaryChineseMedicine.vue?vue&type=script&lang=js&"
export * from "./ProprietaryChineseMedicine.vue?vue&type=script&lang=js&"
import style0 from "./ProprietaryChineseMedicine.vue?vue&type=style&index=0&id=cf01b40c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf01b40c",
  null
  
)

export default component.exports